<script setup lang="ts">
import { type IBookBase } from "~/types/book";

interface IProps {
  html: string,
  book?: IBookBase | null
}

const props = defineProps<IProps>();

const parts = computed(() => props.html.split('<hr>'))
</script>

<template>
  <div class="flex flex-col gap-8">
    <template v-for="(part, index) in parts">
      <lazy-content-book-card v-if="book && index > 0" :book="book" />

      <div
          v-html="part"
          class="content-block flex flex-col gap-8 text-xl leading-6 text-gray-800 dark:text-gray-300 font-light max-md:text-lg max-md:leading-[22px] max-md:gap-4"
      />
    </template>
  </div>
</template>

<style lang="scss">

</style>